/* eslint-disable @typescript-eslint/no-explicit-any */
import { takeLatest, put } from 'redux-saga/effects';
import { SET_SETTINGS_SAGA, SETTINGS_UPDATED } from '../features/settings';
import { SETTINGS_KEYS, storeData, storeSecretByUUID } from '../utils/storage';
import { APP_INIT_SAGA, CLEAR_APP_ERROR } from '../reducers/app';
import { changeLocale } from '../utils/localize';
import { fullQueuesPath } from '../navigation';

function* setSettingsHandler(action: any) {
  const { data, props } = action;
  if (data.locale) {
    changeLocale(data.locale);
  }

  yield put({ type: CLEAR_APP_ERROR });

  const deviceUUID = data.boothId;
  if (deviceUUID) {
    yield storeSecretByUUID(deviceUUID, data.boothSecret);
  }

  yield storeData(SETTINGS_KEYS.APP_SETTINGS, data);
  yield put({ type: SETTINGS_UPDATED, data });
  yield put({ type: APP_INIT_SAGA, payload: props });

  window.location.href = fullQueuesPath(deviceUUID);
}

export function* setSettingsSaga() {
  yield takeLatest(SET_SETTINGS_SAGA, setSettingsHandler);
}
